import React from 'react'
import { Link } from 'react-router-dom';
import './EndPage.css'
import StarRating from '../../components/StarRating';
import { useParams } from 'react-router';
import { useState, useEffect } from 'react';
import fetchData from '../../function/fetchData';
import Invoice from '../invoice/Index';

const EndPage = () => {
  const server = process.env.REACT_APP_SERVER_ADRES;

  //TOKEN FROM GET
  const {tokenOfTrip} = useParams()
  const [review, setReview] = useState(null)
  
  //odešle data
  useEffect( ()=> {
    if(review){
   
      fetchData(server + "api2/reviewFromClient.php", {token: tokenOfTrip, review: review})
      .then((res)=> {
        if(res.info === "OK"){
          console.log(res)
          alert("Děkujeme za Vaší recenzi")
          window.location.href = "/" 
        }
      })
    }
  },[review])

  return (
    <div className='endPageContainer'>
        <Invoice tokenOfTrip={tokenOfTrip}/>
        <br/>
        <br />
        <div className="textContent">
          <h3>Děkujeme za Vaší objednávku a budeme se těšit na další společnou jízdu. </h3>
        </div>
        
        <br/>
        <h2>Jak jste byli spokojeni?</h2>
        <StarRating setReview={setReview}/>
       
     

    </div>
  )
}

export default EndPage
